export default __webpack_public_path__ + "static/media/large-frame-bg2.7625fd67.svg";